var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48349(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0267c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68bbff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48349",
    "data-name": "Group 48349",
    transform: "translate(-1038 -8437)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1038 8437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "instagram",
    d: "M18.353,0H5.647A5.664,5.664,0,0,0,0,5.647V18.353A5.664,5.664,0,0,0,5.647,24H18.353A5.664,5.664,0,0,0,24,18.353V5.647A5.664,5.664,0,0,0,18.353,0Zm4.235,18.353a4.24,4.24,0,0,1-4.235,4.235H5.647a4.24,4.24,0,0,1-4.235-4.235V9.882H5.939a6.623,6.623,0,0,0-.645,2.824,6.706,6.706,0,0,0,13.412,0,6.623,6.623,0,0,0-.645-2.824h4.528Zm-5.294-5.647A5.294,5.294,0,1,1,12,7.412,5.3,5.3,0,0,1,17.294,12.706Zm-.138-4.235a6.615,6.615,0,0,0-10.312,0H1.412V5.647A4.24,4.24,0,0,1,5.647,1.412H18.353a4.24,4.24,0,0,1,4.235,4.235V8.471Zm3.25-4.628V5.675a.768.768,0,0,1-.765.767H17.709a.77.77,0,0,1-.768-.767V3.843a.769.769,0,0,1,.768-.767H19.64a.768.768,0,0,1,.765.767Z",
    transform: "translate(1056 8455)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48349);
export default __webpack_public_path__ + "static/media/Group 48349.8c3aa2b75335cb9b14f66419bb2a392f.svg";
export { ForwardRef as ReactComponent };